import React from 'react'
import './template.css'

const Note = ({ data }) => {
  return (<div className={data.class}>{data.text}</div>)
}

export default Note
